import React, { useCallback } from 'react';

import { cn } from '@/lib/utils';

import styles from './OptionRadioButton.module.scss';

export interface OptionRadioButtonProps {
  option: {
    id: string | number;
    label: string | React.ReactNode | React.JSX.Element;
    value: string;
    icon?: React.ReactNode;
  };
  isSelected: boolean;
  setSelected?: (number) => void;
  size?: 'medium' | 'large';
  onChange?: (event) => void;
  disableSelectedStyles?: boolean;
  disabled?: boolean;
  isTile?: boolean;
  name?: string;
  alignTop?: boolean;
}

const OptionRadioButton = ({
  option,
  isSelected,
  setSelected,
  size,
  onChange = () => {},
  disableSelectedStyles = false,
  disabled,
  isTile,
  name,
  alignTop,
  ref,
}: OptionRadioButtonProps & { ref?: React.Ref<HTMLInputElement> }) => {
  const handleClick = useCallback(() => {
    if (setSelected) {
      setSelected(option.id);
    }
  }, [option.id, setSelected]);

  return (
    <>
      <label
        htmlFor={`option-${option.id}`}
        className={cn(styles.optionContainer, styles[size], {
          [styles.isSelected]: isSelected && !disableSelectedStyles,
          [styles.isTile]: isTile,
        })}
      >
        <div className={cn(styles.nameContainer, styles[size], { [styles.alignTop]: alignTop })}>
          <input
            type="radio"
            name={name ?? `option-${option.value}`}
            value={option.value}
            disabled={disabled}
            id={`option-${option.id}`}
            ref={ref}
            onChange={onChange}
            onClick={handleClick}
            checked={isSelected}
            className={cn(alignTop && 'mt-0.5')}
          />
          {option?.icon}
          {option.label}
        </div>
      </label>
    </>
  );
};

export default OptionRadioButton;
